import { MODAL_NAME } from "../../../constants";
import { getLocalStorage } from "../../../helpers/storage";
import { useAppDispatch } from "../../../hooks/store-hooks";
import { ImagesIcon } from "../../../icons";
import { openModal } from "../../../store/slices/modalSlice";
import ProfileImageComp from "../../common/profile";
import ProfileBadgeAvatar from "../../user/user-profile/profile-avatar";

const SearchBar = () => {
  const dispatch = useAppDispatch();

  const user = JSON.parse(getLocalStorage("userData") || "{}");

  return (
    <div className="mt-2 flex items-center p-4 bg-white rounded-xl mb-4 border border-solid border-primary-600">
      <div>
        {user?.badge ? (
          <div className={`relative w-12 h-[48px]`}>
            <ProfileBadgeAvatar
              profileImage={user?.profile_picture}
              customDivClassName="absolute h-12 w-12 border-[4px] z-1"
              customImgClassName="h-[48px] w-[48px] absolute rounded-full  p-1"
              customIconDivClassName="absolute z-[11] -bottom-[6px] left-[18px]"
              customStyle1="w-[50px] h-4 absolute -bottom-2 z-[11] overflow-hidden"
              customStyle2="w-[200px] h-5 absolute top-3 z-10 -left-10 overflow-hidden"
              customStarWidth={12}
              customStarHeight={12}
              customStyle3="w-[40px] h-[40px]"
              badge={user.badge}
            />
          </div>
        ) : (
          <ProfileImageComp
            imageUrl={user?.profile_picture}
            customClass="h-10 w-10"
            is_opc={user?.memberships?.is_opc}
          />
        )}
      </div>
      <input
        type="text"
        readOnly
        placeholder="Start a post or ask a question"
        className="ml-4 flex-grow p-2 border rounded-lg outline-none text-black"
        onClick={() =>
          dispatch(
            openModal({
              modalName: MODAL_NAME.CREATE_POST,
              isModalOpen: true,
            }),
          )
        }
      />
      <div
        className="ml-4 h-12 w-12 p-2 flex items-center justify-center cursor-pointer"
        onClick={() =>
          dispatch(
            openModal({
              modalName: MODAL_NAME.CREATE_POST,
              isModalOpen: true,
              modalData: { isImageFirst: true },
            }),
          )
        }
      >
        <ImagesIcon />
      </div>
    </div>
  );
};

export default SearchBar;
